import Loadable from '../../components/loadable';

const PosSale = Loadable({
  loader: () => import('../../pages/pos/sale/index'),
  type: 'block',
});

angular.module('gym').value('PosSale', PosSale);

const PosProductsListFiltersModal = Loadable({
  loader: () => import('../../pages/pos/sale/pos_products_list_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('PosProductsListFiltersModal', PosProductsListFiltersModal);

const PosLinkCustomerHintModal = Loadable({
  loader: () => import('../../pages/pos/sale/pos_link_customer_hint_modal'),
  type: 'modal',
});

angular.module('gym').value('PosLinkCustomerHintModal', PosLinkCustomerHintModal);
